/**
 * ÐÑÐ°Ð²Ð¸Ð»Ð° Ð¾ÐºÐ½Ð° Â«ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸Â».
 *
 * ÐÑÐ½ÐµÑÐµÐ½Ð¾ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ° Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÐµÑÑÐ°Ð¼Ð¸:
 * Ð¾Ð±Ð° Ð¾Ð½Ð¸ ÑÐ¶Ðµ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¾ÑÐ¸Ð±Ð°Ð»Ð¸ÑÑ Ð½Ð° Ð±Ð¾Ñ.
 */

/**
 * Ð§ÑÐ¾ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð¿Ð¾ ÐºÐ¾Ð½ÐºÑÐµÑÐ½Ð¾Ð¼Ñ Ð±Ð°Ð½ÐºÑ. ÐÑÐºÐµÐ½Ð´ Ð¿Ð¾Ð¼ÐµÑÐ°ÐµÑ Ð¾ÑÐ²ÐµÑ Ð±Ð°Ð½ÐºÐ° Ð² json Ð·Ð°ÑÐ²ÐºÐ¸
 * (submit_state) ÑÑÐ°Ð·Ñ, ÐºÐ°Ðº Ð±Ð°Ð½Ðº Ð¾ÑÐ²ÐµÑÐ¸Ð», â ÑÑÐ¾ Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð¸ÑÑÐ¾ÑÐ½Ð¸Ðº. ÐÑÑÐ°Ð»ÑÐ½Ð¾Ðµ
 * Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð·Ð°Ð¿Ð°ÑÐ½ÑÐ¼ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð¼: Ð·Ð°ÑÐ²ÐºÐ¸, Ð¿Ð¾Ð´Ð°Ð½Ð½ÑÐµ Ð´Ð¾ ÑÑÐ¾Ð¹ Ð¿ÑÐ°Ð²ÐºÐ¸, Ð¿Ð¾Ð»Ñ Ð½Ðµ Ð¸Ð¼ÐµÑÑ.
 */
export const resolveAppealState = (appeal) => {
  let submitState = null;
  try {
    submitState = JSON.parse(appeal?.json || '{}')?.submit_state || null;
  } catch (e) {
    submitState = null;
  }
  if (submitState === 'accepted' || submitState === 'failed') return submitState;
  if (appeal?.bankOwnerId) return 'accepted';
  if (appeal?.errorMessage) return 'failed';
  return 'pending';
};

/**
 * ÐÑÐºÑÑÐ²Ð°ÑÑ Ð»Ð¸ Ð¾ÐºÐ½Ð¾ Ð¿ÑÐ¾Ð³ÑÐµÑÑÐ°.
 *
 * ÐÐ¸ Ð¾Ð´Ð½Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐ¸ â Ð¾ÐºÐ½Ð¾ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼. ÐÐ° Ð¿ÐµÑÐ²Ð¾Ð¼ ÐºÐ»Ð¸ÐºÐµ Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸
 * Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑÂ» Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸ Ð½Ðµ ÑÑÐ¾Ð´ÑÑ: Ð±ÑÐºÐµÐ½Ð´ Ð¾ÑÐ²ÐµÑÐ°ÐµÑ Â«ÐÐ¢Ð Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Â», Ð¸
 * Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¸Ð´ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ. ÐÐºÐ½Ð¾ Ð² ÑÑÐ¾Ñ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¿Ð¸ÑÐ°Ð»Ð¾
 * Â«Ð·Ð°ÑÐ²ÐºÐ¸ ÑÐ¶Ðµ ÑÑÐ»Ð¸ Ð² Ð±Ð°Ð½ÐºÐ¸Â» Ð¸ Ð²Ð²Ð¾Ð´Ð¸Ð»Ð¾ Ð² Ð·Ð°Ð±Ð»ÑÐ¶Ð´ÐµÐ½Ð¸Ðµ.
 */
export const shouldShowSendProgress = ({ loading, banks, error } = {}) => {
  if (error) return true;
  return !!loading && (banks?.length || 0) > 0;
};

/**
 * ÐÐ¾Ð¶Ð½Ð¾ Ð»Ð¸ ÑÑÐ¸ÑÐ°ÑÑ ÑÐµÑÐ½Ð¾Ð²Ð¸Ðº Ð°Ð½ÐºÐµÑÑ. Ð¢Ð¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ ÑÐµÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸: ÑÐ°Ð½ÑÑÐµ
 * ÑÐµÑÐ½Ð¾Ð²Ð¸Ðº ÑÑÐ¸ÑÐ°Ð»ÑÑ Ð½Ð° Ð»ÑÐ±Ð¾Ð¼ Ð¸ÑÑÐ¾Ð´Ðµ, Ð² ÑÐ¾Ð¼ ÑÐ¸ÑÐ»Ðµ Ð½Ð° Ð¿ÐµÑÐ²Ð¾Ð¼ ÐºÐ»Ð¸ÐºÐµ, Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ,
 * Ð¾Ð±Ð½Ð¾Ð²Ð¸Ð² ÑÑÑÐ°Ð½Ð¸ÑÑ, Ð¿Ð¾ÐºÐ° ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ, Ð¿Ð¾Ð»ÑÑÐ°Ð» Ð¿ÑÑÑÑÑ Ð°Ð½ÐºÐµÑÑ.
 */
export const shouldClearDraft = (submitResult) => submitResult?.sent === true;

/**
 * Ð¡ÑÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸ Ð±Ð°Ð½ÐºÐ° Ð±ÐµÐ· ÑÐµÑÐ½Ð¸ÑÐµÑÐºÐ¾Ð³Ð¾ ÑÐ²Ð¾ÑÑÐ°.
 *
 * Ð ÐºÐ°ÑÑÐ¾ÑÐºÐµ ÑÐ´ÐµÐ»ÐºÐ¸ Ðº ÑÐµÐºÑÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸ Ð¿Ð¾Ð´ÐºÐ»ÐµÐ¸Ð²Ð°Ð»ÑÑ ÑÑÐµÐº Ð¸ÑÐºÐ»ÑÑÐµÐ½Ð¸Ñ Ð¿Ð¾ÑÐ»Ðµ Ð¼ÐµÑÐºÐ¸
 * Â«--- TRACE ---Â»: Ñ Ð¤Ð¾ÑÑÐµ ÑÑÐ¾ Ð´Ð¾ÑÐ¾Ð´Ð¸Ð»Ð¾ Ð´Ð¾ 2500 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð², Ð¸ ÑÑÑÑ ÑÐ¾Ð½ÑÐ»Ð°. Ð¡ÑÐµÐº
 * Ð¾ÑÑÐ°ÑÑÑÑ Ð² Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð¼ Ð»Ð¾Ð³Ðµ, Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¾Ð½ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½. Ð¡ÑÐ°ÑÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸ ÑÐ²Ð¾ÑÑ ÑÐ¶Ðµ
 * ÑÐ¾Ð´ÐµÑÐ¶Ð°Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐµÐ¶ÐµÐ¼ Ð¸ Ð¿ÑÐ¸ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ð¸, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¸ Ð·Ð°Ð¿Ð¸ÑÐ¸.
 */
const MESSAGE_FIELDS = ['message', 'errorMessage', 'error_description', 'description', 'error', 'detail'];

// ÐÐ¾ÑÑÐ°ÑÑ ÑÐµÐ»Ð¾Ð²ÐµÑÐµÑÐºÑÑ ÑÑÑÐ¾ÐºÑ Ð¸Ð· JSON-Ð¾ÑÐ²ÐµÑÐ° Ð±Ð°Ð½ÐºÐ°. Ð¢Ð¤Ð¡ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ ÑÑÑÑÐºÐ¸Ð¹ ÑÐµÐºÑÑ
// Ð² \u-ÑÐºÑÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸ â Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¾Ð½ ÑÐ¸ÑÐ°Ð»ÑÑ ÐºÐ°Ðº Ð½Ð°Ð±Ð¾Ñ ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð².
const messageFromJson = (text) => {
  const trimmed = text.trim();
  if (!trimmed.startsWith('{')) return null;

  let parsed;
  try {
    parsed = JSON.parse(trimmed);
  } catch (e) {
    return null;
  }

  for (const field of MESSAGE_FIELDS) {
    const value = parsed?.[field];
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value && typeof value === 'object') {
      const nested = messageFromJson(JSON.stringify(value));
      if (nested) return nested;
    }
  }
  return null;
};

export const bankErrorSummary = (errorMessage) => {
  if (!errorMessage) return errorMessage;
  const withoutTrace = String(errorMessage).split('--- TRACE ---')[0].trim();
  return messageFromJson(withoutTrace) || withoutTrace;
};

/**
 * ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð»Ð¸ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ ÑÑÐ°ÑÑÑ Ð±Ð°Ð½ÐºÐ° (Â«ÐÐ¶Ð¸Ð´Ð°ÐµÑ ÑÐ°ÑÑÐ¼Ð¾ÑÑÐµÐ½Ð¸ÑÂ» Ñ Ð¨Ð¸Ð½ÑÐ°Ð½Ð°).
 *
 * ÐÐ½ Ð¿Ð¸ÑÐµÑÑÑ Ð² Ð·Ð°ÑÐ²ÐºÑ Ð² Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¿Ð¾Ð´Ð°ÑÐ¸ Ð¸ Ð¿Ð¾ÑÐ¾Ð¼ Ð½Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐµÑÑÑ. ÐÐ¾Ð³Ð´Ð° Ð±Ð°Ð½Ðº
 * Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ ÑÐµÑÐµÐ½Ð¸Ðµ, ÑÑÐ°ÑÑÑ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¼ÐµÐ½ÑÐµÑÑÑ Ð½Ð° Â«Ð¾ÑÐºÐ°Ð·Ð°Ð½Ð¾Â», Ð° ÑÑÐ° ÑÑÑÐ¾ÐºÐ°
 * Ð¾ÑÑÐ°Ð²Ð°Ð»Ð°ÑÑ Ð¿ÑÐµÐ¶Ð½ÐµÐ¹ â Ð½Ð° ÑÐ´ÐµÐ»ÐºÐµ 189321 Ð¨Ð¸Ð½ÑÐ°Ð½ Ð¾ÑÐºÐ°Ð·Ð°Ð», Ð° Ð¿Ð¾Ð´ ÐºÐ°ÑÑÐ¾ÑÐºÐ¾Ð¹ Ð²ÑÑ
 * ÐµÑÑ Ð²Ð¸ÑÐµÐ»Ð¾ Â«ÐÐ¶Ð¸Ð´Ð°ÐµÑ ÑÐ°ÑÑÐ¼Ð¾ÑÑÐµÐ½Ð¸ÑÂ». ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÐºÐ° ÑÐµÑÐµÐ½Ð¸Ñ Ð½ÐµÑ.
 */
export const shouldShowBankStatus = (appeal) => {
  if (appeal?.errorMessage) return false;
  return appeal?.statusId === 1;
};
